import { render, staticRenderFns } from "./StaticContent.vue?vue&type=template&id=195083fc&"
import script from "./StaticContent.vue?vue&type=script&lang=js&"
export * from "./StaticContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports